import React, { useRef, useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BsInfoCircle } from "react-icons/bs";
import PhoneInput from "react-phone-input-2";
import { Select } from "antd";
import "react-phone-input-2/lib/style.css";
import "./MemberSetupPhone.scss";
import PrimaryButton from "../../common/PrimaryButton";
import SearchableSelect from "../../common/SearchableSelect";
import ConfirmationPopup from "../../common/ConfirmationPopup";

import SwoodleLogo from "../../../Assets/Icons/SwoodleUpdatedLogo.svg";
import QuestionMarkIcon from "../../../Assets/Icons/questionmark.svg";
import {
  checkout,
  getSubscriptionPlans,
  getUserSubscription,
} from "../../../services/subscriptionService";
import { useDispatch, useSelector } from "react-redux";
import {
  sendSignupOtp,
  verifySignupOtp,
  emailVerification,
  signUp,
  login,
  saveMemberSignupDraft,
} from "../../../services/authService";
import {
  getFundraiserCategories,
  getFundraisersByCategoryId,
  getSubCategoriesByCategoryId,
  getFundraisersBySubCategoryId,
  getFundraiserContent,
  updateReferredBy,
} from "../../../services/fundraiserService";
import {
  clearMemberFundraiserPickerData,
  clearMemberFundraiserResults,
} from "../../../redux/slices/fundraiserSlice";
import toast from "../../../utils/toast";
import { getTokenData } from "../../../utils/connectStore";
import { clearAuth } from "../../../redux/slices/authSlice";
import { sortedVictorianSuburbs } from "../../../utils/victorianSuburbs";
import { fetchSuburbsByState } from "../../../services/locationLookupService";
import { isValidPhoneNumberForCountry } from "../../../utils/phoneValidation";
import "../ComingSoon/comingsoon.scss";
import axios from "../../../utils/axios";
import LinkedAccountPasswordModal from "../../common/LinkedAccountPasswordModal";
import { verifySignupExistingPassword } from "../../../services/authService";

const MobileView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const signupResume = location.state?.signupResume;
  const isSignupResume = signupResume?.role === "member";
  const resumeAppliedRef = useRef(false);
  const MEMBER_FUNDRAISER_STANDARD_CATEGORY_ORDER = [
    "Schools",
    "Sporting Clubs",
    "Community Organisations",
  ];
  const MEMBER_FUNDRAISER_CATEGORIES_WITH_SUBCATEGORY = [
    "Schools",
    "Sporting Clubs",
  ];

  const getExistingEmailInlineMessage = (role) => {
    switch (String(role || "").toLowerCase()) {
      case "member":
      case "user":
        return "This email is already registered. Please log in through the mobile app to continue.";
      case "merchant":
        return "This email is registered as a merchant account.";
      case "fundraiser":
        return "This email is registered as a fundraiser account.";
      case "admin":
        return "This email is registered as an admin account.";
      default:
        return "This email is already registered.";
    }
  };

  const STRIPE_CHECKOUT_URL = process.env.REACT_APP_STRIPE_CHECKOUT_URL || "";
  const invitedEmail = useSelector(
    (state) => state?.onboardingReducer?.fundraiserInviteSent?.email,
  );
  console.log("check invited email", invitedEmail);
  useEffect(() => {
    if (isSignupResume) return;
    console.log("Clearing signup state");
    localStorage.removeItem("email");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("newMemberData");
    localStorage.removeItem("fundraiserCategories");
    localStorage.removeItem("subscriptionPlans");
    localStorage.removeItem("memberSetup.email");
    localStorage.removeItem("userProfile");
    localStorage.removeItem("userPassword");
    localStorage.removeItem("memberSetup.step");
    setEmail("");
    dispatch(clearAuth());
  }, [isSignupResume, dispatch]);

  const clearMemberSetupProgress = () => {
    [
      "memberSetup.step",
      "memberSetup.email",
      "userProfile",
      "userPassword",
      "memberSetup.fund",
      "memberSetup.restoreMode",
    ].forEach((key) => localStorage.removeItem(key));
  };

  const resetMemberDraftState = () => {
    setFirstName("");
    setLastName("");
    setAge("");
    setPhone("");
    setGender(genderOptions[0]);
    pendingDraftSuburbRef.current = "";
    setSuburb("");
    setSelectedState("");
    setPostalCode("");
    setPassword("");
    setConfirmPassword("");
    setHasExistingAccount(false);
    setFundCategory("");
    setFundSubcat("");
    setFundSubcatIds([]);
    setFundName("");
    setSelectedFundraiserId(null);
  };

  const inEmail = useSelector(
    (state) => state?.onboardingReducer?.fundraiserInviteSent?.email,
  );
  console.log("In emaaaail", inEmail);
  const { loading: authLoading = false } = useSelector(
    (state) => state?.authReducer || {},
  );
  const { loading: subscriptionLoading = false } = useSelector(
    (state) => state?.subscriptionReducer || {},
  );
  const {
    fundraiserCategories: categories = [],
    subCategories = [],
    fundraisers = [],
    loading: fundraiserLoading = false,
  } = useSelector((state) => state?.fundraiserReducer || {});

  const [step, setStep] = useState(0); // 0 = email/otp, 1 = profile, 2 = password, 3 = subscription
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const pendingDraftSuburbRef = useRef("");
  const [email, setEmail] = useState("");
  const [signupProof, setSignupProof] = useState("");
  const [existingAccountRoles, setExistingAccountRoles] = useState([]);
  const [showLinkedAccountPasswordModal, setShowLinkedAccountPasswordModal] =
    useState(false);
  const emailInputRef = useRef(null);
  const [awaitingOtp, setAwaitingOtp] = useState(false);
  const [emailExists, setEmailExists] = useState("");
  const [hasExistingAccount, setHasExistingAccount] = useState(false);
  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const [restoreMode, setRestoreMode] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState(null);
  const [checkingSubscription, setCheckingSubscription] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpTimeLeft, setOtpTimeLeft] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const otpRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  // Suburbs are loaded after selecting a state
  const [suburbOptions, setSuburbOptions] = useState([]);
  const [suburbLoading, setSuburbLoading] = useState(false);
  const [suburb, setSuburb] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const stateOptions = [
    { label: "Australian Capital Territory (ACT)", value: "ACT" },
    { label: "New South Wales", value: "NSW" },
    { label: "Northern Territory (NT)", value: "NT" },
    { label: "Queensland", value: "QLD" },
    { label: "South Australia", value: "SA" },
    { label: "Tasmania", value: "TAS" },
    { label: "Victoria", value: "VIC" },
    { label: "Western Australia", value: "WA" },
  ];

  const [suppressPersist, setSuppressPersist] = useState(false);

  // Coming Soon Waitlist State
  const [comingSoonScreen, setComingSoonScreen] = useState(1);
  const [waitlistPhone, setWaitlistPhone] = useState("");
  const [offersFeedback, setOffersFeedback] = useState("");
  const [brandsFeedback, setBrandsFeedback] = useState("");
  const [referralSource, setReferralSource] = useState("");
  const [generalFeedback, setGeneralFeedback] = useState("");
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [waitlistLoading, setWaitlistLoading] = useState(false);

  // Profile fields
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nameErrors, setNameErrors] = useState({ first: false, last: false });
  const [validationErrors, setValidationErrors] = useState([]);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  useEffect(() => {
    if (!isSignupResume || resumeAppliedRef.current) return;
    resumeAppliedRef.current = true;
    setEmail(signupResume.email || "");
    setSignupProof(signupResume.proof || "");
    setPassword(signupResume.password || "");
    setConfirmPassword(signupResume.password || "");
    setHasExistingAccount(true);
    const savedStep = Number(signupResume.resumeStep);
    setStep(Number.isInteger(savedStep) && savedStep >= 1 && savedStep <= 2 ? savedStep : 1);
    const code = String(signupResume.signupOtpCode || "").split("");
    setOtp([...code, ...Array(Math.max(0, 6 - code.length)).fill("")].slice(0, 6));
    setAwaitingOtp(false);
    navigate(location.pathname, { replace: true, state: null });
  }, [isSignupResume, signupResume, navigate, location.pathname]);
  const [profileLoading, setProfileLoading] = useState(false);
  const nameRegex = /^[\p{L}\p{M}\s'’-]*$/u;

  // Individual field errors
  const [fieldErrors, setFieldErrors] = useState({
    firstName: "",
    lastName: "",
    age: "",
    phone: "",
    suburb: "",
    password: "",
    confirmPassword: "",
    selectedState: "",
    postalCode: "",
  });
  const [age, setAge] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneCountry, setPhoneCountry] = useState("au");
  const genderOptions = ["Male", "Female", "Other"];
  const [gender, setGender] = useState(genderOptions[0]);
  const [genderOpen, setGenderOpen] = useState(false);

  // Skip modal
  const [showSkipModal, setShowSkipModal] = useState(false);

  // Fundraiser data
  const [supportOpen, setSupportOpen] = useState(false);
  const [fundCategory, setFundCategory] = useState("");
  const [fundSubcat, setFundSubcat] = useState("");
  const [fundSubcatIds, setFundSubcatIds] = useState([]);
  const [fundSubcatOpen, setFundSubcatOpen] = useState(false);
  const [fundName, setFundName] = useState("");
  const [fundraiserNameSearch, setFundraiserNameSearch] = useState("");
  const [skipAutoSelect, setSkipAutoSelect] = useState(false);
  const [selectedFundraiserId, setSelectedFundraiserId] = useState(null);
  const genderRef = useRef(null);
  const fundSubcatRef = useRef(null);
  const memberVisibleFundraiserCategoryOptions = useMemo(
    () =>
      [
        ...MEMBER_FUNDRAISER_STANDARD_CATEGORY_ORDER.map((title) =>
          (categories || []).find((category) => category?.title === title),
        ).filter(Boolean),
        ...(categories || []).filter(
          (category) =>
            category?.title &&
            !MEMBER_FUNDRAISER_STANDARD_CATEGORY_ORDER.includes(category.title),
        ),
      ].map((category) => ({
        label: category?.title || "",
        value: category?.title || "",
      })),
    [categories],
  );
  const selectedCategoryRequiresSubcategory =
    MEMBER_FUNDRAISER_CATEGORIES_WITH_SUBCATEGORY.includes(fundCategory);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (genderRef.current && !genderRef.current.contains(event.target))
        setGenderOpen(false);
      if (
        fundSubcatRef.current &&
        !fundSubcatRef.current.contains(event.target)
      )
        setFundSubcatOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Restore persisted state on mount (step, form fields, selections)
  useEffect(() => {
    try {
      const savedStep = parseInt(
        localStorage.getItem("memberSetup.step") || "",
        10,
      );
      if (!isSignupResume && !Number.isNaN(savedStep) && savedStep >= 0 && savedStep <= 3) {
        setStep(savedStep);
      }
      // If stored email belongs to a different invite, clear old state
      const savedEmail = localStorage.getItem("memberSetup.email");
      if (
        invitedEmail &&
        savedEmail &&
        savedEmail.toLowerCase() !== String(invitedEmail).toLowerCase()
      ) {
        localStorage.removeItem("memberSetup.step");
        localStorage.removeItem("memberSetup.email");
        localStorage.removeItem("userProfile");
        localStorage.removeItem("userPassword");
        localStorage.removeItem("memberSetup.fund");
      }
      if (invitedEmail && !savedEmail) setEmail(invitedEmail);
      else if (savedEmail) setEmail(savedEmail);
      const savedProfile = localStorage.getItem("userProfile");
      if (savedProfile) {
        const p = JSON.parse(savedProfile);
        if (p.firstName) setFirstName(p.firstName);
        if (p.lastName) setLastName(p.lastName);
        if (p.age) setAge(p.age);
        if (p.phone) setPhone(p.phone);
        if (p.suburb) setSuburb(p.suburb);
        if (p.state) setSelectedState(p.state);
        if (p.postalCode) setPostalCode(p.postalCode);
        if (p.gender) setGender(p.gender);
      }
      const savedPwd = localStorage.getItem("userPassword");
      if (!isSignupResume && savedPwd) {
        const pd = JSON.parse(savedPwd);
        if (pd.password) setPassword(pd.password);
        if (pd.confirmPassword) setConfirmPassword(pd.confirmPassword);
      }
      const savedFund = localStorage.getItem("memberSetup.fund");
      if (savedFund) {
        const f = JSON.parse(savedFund);
        if (f.fundCategory) setFundCategory(f.fundCategory);
        if (f.fundSubcat) setFundSubcat(f.fundSubcat);
        if (Array.isArray(f.fundSubcatIds)) setFundSubcatIds(f.fundSubcatIds);
        if (f.fundName) setFundName(f.fundName);
      }
      setRestoreMode(
        localStorage.getItem("memberSetup.restoreMode") === "true",
      );
    } catch (_) {}
    // If user hard-refreshed on the subscription step (step 3), reset only that step's transient selections
    if (!isSignupResume && Number(localStorage.getItem("memberSetup.step")) === 3) {
      setSkipAutoSelect(true);
      setFundCategory("");
      setFundSubcat("");
      setFundName("");
      localStorage.removeItem("memberSetup.fund");
    }
  }, [isSignupResume, invitedEmail]);

  // Persist key fields to localStorage as user proceeds
  useEffect(() => {
    if (!suppressPersist) {
      localStorage.setItem("memberSetup.step", String(step));
    }
  }, [step, suppressPersist]);
  useEffect(() => {
    if (email) localStorage.setItem("memberSetup.email", email);
  }, [email]);
  useEffect(() => {
    const profileData = {
      firstName,
      lastName,
      age,
      phone,
      suburb,
      gender,
      state: selectedState,
      postalCode,
    };
    localStorage.setItem("userProfile", JSON.stringify(profileData));
  }, [
    firstName,
    lastName,
    age,
    phone,
    suburb,
    gender,
    selectedState,
    postalCode,
  ]);
  useEffect(() => {
    if (hasExistingAccount) {
      localStorage.removeItem("userPassword");
      return;
    }
    const pwd = { password, confirmPassword };
    localStorage.setItem("userPassword", JSON.stringify(pwd));
  }, [password, confirmPassword, hasExistingAccount]);
  useEffect(() => {
    const fund = { fundCategory, fundSubcat, fundName, fundSubcatIds };
    localStorage.setItem("memberSetup.fund", JSON.stringify(fund));
  }, [fundCategory, fundSubcat, fundName, fundSubcatIds]);

  // Load fundraiser categories on component mount
  useEffect(() => {
    dispatch(getFundraiserCategories({ memberSignup: true }));
  }, [dispatch]);

  // Load subscription plans and fundraiser data when reaching subscription step
  useEffect(() => {
    if (step === 3) {
      // Clear any pre-filled fundraiser selections when entering Subscription step
      setSkipAutoSelect(true);
      setFundCategory("");
      setFundSubcat("");
      setFundSubcatIds([]);
      setFundName("");
      setSelectedFundraiserId(null);
      localStorage.removeItem("memberSetup.fund");
      // Ensure subscription plans are loaded
      dispatch(getSubscriptionPlans({}));
      // Ensure fundraiser categories are loaded
      dispatch(getFundraiserCategories({ memberSignup: true }));

      // Check if user already has an active subscription
      const checkActiveSubscription = async () => {
        try {
          if (getTokenData()) {
            setCheckingSubscription(true);
            const result = await dispatch(getUserSubscription()).unwrap();
            if (
              result?.success === true &&
              Array.isArray(result?.data) &&
              result?.data?.length > 0
            ) {
              const activeSub = result.data.find(
                (sub) => String(sub.status).toLowerCase() === "active",
              );
              if (activeSub) {
                setActiveSubscription(activeSub);
              }
            }
          }
        } catch (err) {
          console.warn("Error checking active subscription:", err);
        } finally {
          setCheckingSubscription(false);
        }
      };
      checkActiveSubscription();
    }
  }, [step, dispatch]);

  // Load subscription plans for final step checkout
  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const result = await dispatch(getSubscriptionPlans({})).unwrap();
        if (!isMounted) return;
        if (result?.success === true && Array.isArray(result?.data)) {
          setSubscriptionPlans(result.data);
          if (!selectedPlan && result.data.length > 0)
            setSelectedPlan(result.data[0]);
        }
      } catch (e) {
        // ignore
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  // OTP timer effect
  useEffect(() => {
    if (!awaitingOtp) return;
    if (otpTimeLeft <= 0) {
      setCanResend(true);
      return;
    }
    const t = setTimeout(() => setOtpTimeLeft((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [awaitingOtp, otpTimeLeft]);

  useEffect(() => {
    let cancelled = false;
    const preservedSuburb = pendingDraftSuburbRef.current;

    if (!preservedSuburb) {
      setSuburb("");
    }
    setFieldErrors((prev) => ({ ...prev, suburb: "" }));

    if (!selectedState) {
      setSuburbOptions([]);
      setSuburbLoading(false);
      return () => {
        cancelled = true;
      };
    }

    (async () => {
      setSuburbLoading(true);
      try {
        const suburbs = await fetchSuburbsByState(selectedState);
        if (cancelled) return;
        setSuburbOptions(suburbs);
        if (pendingDraftSuburbRef.current) {
          setSuburb(pendingDraftSuburbRef.current);
          pendingDraftSuburbRef.current = "";
        }
      } catch (e) {
        if (cancelled) return;
        if (String(selectedState).toUpperCase() === "VIC") {
          setSuburbOptions(sortedVictorianSuburbs);
        } else {
          setSuburbOptions([]);
        }
        if (pendingDraftSuburbRef.current) {
          setSuburb(pendingDraftSuburbRef.current);
          pendingDraftSuburbRef.current = "";
        }
      } finally {
        if (!cancelled) setSuburbLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [selectedState]);

  useEffect(() => {
    const resetScrollPosition = () => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    resetScrollPosition();
    const frame = window.requestAnimationFrame(resetScrollPosition);

    return () => window.cancelAnimationFrame(frame);
  }, [step]);

  // Do not auto-select a fundraiser category. Wait for the user to choose one.
  useEffect(() => {
    if (categories?.length > 0 && !fundCategory && !skipAutoSelect) {
      dispatch(clearMemberFundraiserPickerData());
    }
  }, [
    categories,
    fundCategory,
    skipAutoSelect,
    dispatch,
    memberVisibleFundraiserCategoryOptions,
  ]);

  // Do not auto-select sub-categories; wait for user action
  useEffect(() => {
    if (skipAutoSelect) return;
    // no-op: user must select sub-categories manually
  }, [subCategories, skipAutoSelect]);

  // Set initial fundraiser when data loads
  useEffect(() => {
    if (fundraisers && fundraisers.length > 0 && !fundName) {
      // do not auto-select; keep blank for clarity
    }
  }, [fundraisers, fundName]);

  // API Functions
  const handleEmailVerification = async () => {
    try {
      const normalizedEmail = String(email || "")
        .trim()
        .toLowerCase();
      const savedEmail = String(localStorage.getItem("memberSetup.email") || "")
        .trim()
        .toLowerCase();
      if (normalizedEmail && savedEmail && normalizedEmail !== savedEmail) {
        ["userProfile", "userPassword", "memberSetup.fund"].forEach((key) =>
          localStorage.removeItem(key),
        );
        localStorage.removeItem("memberSetup.restoreMode");
        setRestoreMode(false);
        resetMemberDraftState();
      }
      const result = await dispatch(sendSignupOtp({ email, role: "member" }));
      if (result.payload?.success) {
        if (result.payload?.restoreRequired) {
          setShowRestoreModal(true);
          setEmailExists("");
          return;
        }
        setAwaitingOtp(true);
        setOtpTimeLeft(60);
        setCanResend(false);
        setEmailExists("");
        setRestoreMode(false);
        localStorage.removeItem("memberSetup.restoreMode");
        toast.success("OTP sent to your email");
      } else {
        // Check if the error is about email already existing or invalid domain
        const errorMessage = result.payload?.message || "Failed to send OTP";
        const existingRole = result.payload?.role;
        const lowerMessage = errorMessage.toLowerCase();
        if (
          lowerMessage.includes("domain") ||
          lowerMessage.includes("provide valid email") ||
          lowerMessage.includes("invalid email") ||
          lowerMessage.includes("provide email")
        ) {
          setEmailExists(errorMessage);
        } else if (
          lowerMessage.includes("already exists") ||
          lowerMessage.includes("already registered")
        ) {
          const existingEmailMessage =
            getExistingEmailInlineMessage(existingRole);
          setEmailExists(existingEmailMessage);
        } else {
          toast.error(errorMessage);
        }
      }
    } catch (error) {
      toast.error("Failed to send OTP");
    }
  };

  const handleRestoreConfirmation = async () => {
    try {
      const result = await dispatch(
        sendSignupOtp({ email, role: "member", restore: true }),
      );
      if (result.payload?.success) {
        setShowRestoreModal(false);
        setRestoreMode(true);
        localStorage.setItem("memberSetup.restoreMode", "true");
        setAwaitingOtp(true);
        setOtpTimeLeft(60);
        setCanResend(false);
        setEmailExists("");
        toast.success("OTP sent to your email");
        return;
      }

      toast.error(result.payload?.message || "Failed to send OTP");
    } catch (error) {
      toast.error("Failed to send OTP");
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text");
    const cleanData = pastedData.replace(/\D/g, "").slice(0, 6);

    if (cleanData.length === 6) {
      const newOtp = cleanData.split("");
      setOtp(newOtp);
      // Focus on the last field
      otpRefs[5].current?.focus();
    }
  };

  const handleOtpInputChange = (e, index) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 1);
    const next = [...otp];
    next[index] = val;
    setOtp(next);

    if (val && index < 5) {
      otpRefs[index + 1].current?.focus();
    }
  };

  const handleLoginClick = () => {
    // Navigate to login page
    window.location.href = "/existing-login";
  };

  // Deep link back to the mobile app and try to close the browser/webview
  const handleSkipLoginDeepLink = () => {
    const deeplink = process.env.REACT_APP_APP_DEEPLINK || "swoodle://open";
    const fallbackDeeplink =
      process.env.REACT_APP_APP_LOGIN_DEEPLINK || "swoodle://login";
    try {
      // Notify React Native WebView if present
      if (window?.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "NAVIGATE", url: deeplink }),
        );
      }
      // Try direct deep link navigation
      window.location.assign(deeplink);
      // Backup attempt
      setTimeout(() => {
        try {
          window.location.assign(fallbackDeeplink);
        } catch (_) {}
      }, 150);
    } catch (_) {}

    // Try to close the current browser tab/webview shortly after
    setTimeout(() => {
      try {
        window.close();
      } catch (_) {}
    }, 600);
  };

  // Validation functions
  const validateProfileStep = () => {
    const newFieldErrors = {
      firstName: "",
      lastName: "",
      age: "",
      phone: "",
      suburb: "",
      selectedState: "",
      postalCode: "",
    };

    let hasErrors = false;

    if (!firstName.trim()) {
      newFieldErrors.firstName = "First name is required";
      hasErrors = true;
    } else if (!nameRegex.test(firstName)) {
      newFieldErrors.firstName = "First name contains invalid characters";
      hasErrors = true;
    }

    if (!lastName.trim()) {
      newFieldErrors.lastName = "Last name is required";
      hasErrors = true;
    } else if (!nameRegex.test(lastName)) {
      newFieldErrors.lastName = "Last name contains invalid characters";
      hasErrors = true;
    }

    if (!age.trim()) {
      newFieldErrors.age = "Age is required";
      hasErrors = true;
    } else if (isNaN(age) || parseInt(age) < 5 || parseInt(age) > 95) {
      newFieldErrors.age = "Age must be between 5 and 95";
      hasErrors = true;
    }

    if (!phone.trim()) {
      newFieldErrors.phone = "Phone number is required";
      hasErrors = true;
    } else if (!isValidPhoneNumberForCountry(phone, phoneCountry)) {
      newFieldErrors.phone = "Please enter a valid phone number";
      hasErrors = true;
    }

    if (!suburb.trim()) {
      newFieldErrors.suburb = "Suburb is required";
      hasErrors = true;
    }

    if (!selectedState) {
      newFieldErrors.selectedState = "State is required";
      hasErrors = true;
    }

    if (postalCode.trim() && postalCode.trim().length !== 4) {
      newFieldErrors.postalCode = "Postal code must be exactly 4 digits";
      hasErrors = true;
    }

    setFieldErrors((prev) => ({ ...prev, ...newFieldErrors }));
    return !hasErrors;
  };

  const validatePasswordStep = () => {
    const newFieldErrors = {
      password: "",
      confirmPassword: "",
    };

    let hasErrors = false;

    if (!password.trim()) {
      newFieldErrors.password = "Password is required";
      hasErrors = true;
    } else if (password.length < 8) {
      newFieldErrors.password = "Password must be at least 8 characters long";
      hasErrors = true;
    } else if (!/(?=.*[0-9])/.test(password)) {
      newFieldErrors.password = "Password must contain at least one number";
      hasErrors = true;
    } else if (!/(?=.*[!@#$%^&*])/.test(password)) {
      newFieldErrors.password =
        "Password must contain at least one special character";
      hasErrors = true;
    }

    if (!hasExistingAccount) {
      if (!confirmPassword.trim()) {
        newFieldErrors.confirmPassword = "Please confirm your password";
        hasErrors = true;
      } else if (password !== confirmPassword) {
        newFieldErrors.confirmPassword = "Passwords do not match";
        hasErrors = true;
      }
    }

    setFieldErrors((prev) => ({ ...prev, ...newFieldErrors }));
    return !hasErrors;
  };

  const validatePasswordOnly = () => {
    let message = "";
    if (!password.trim()) {
      message = "Password is required";
    } else if (password.length < 8) {
      message = "Password must be at least 8 characters long";
    } else if (!/(?=.*[0-9])/.test(password)) {
      message = "Password must contain at least one number";
    } else if (!/(?=.*[!@#$%^&*])/.test(password)) {
      message = "Password must contain at least one special character";
    }
    setFieldErrors((prev) => ({ ...prev, password: message }));
  };

  const validateConfirmOnly = () => {
    let message = "";
    if (!confirmPassword.trim()) {
      message = "Please confirm your password";
    } else if (password !== confirmPassword) {
      message = "Passwords do not match";
    }
    setFieldErrors((prev) => ({ ...prev, confirmPassword: message }));
  };

  const saveProfileData = async () => {
    // Here you would typically save to backend or local storage
    const profileData = {
      firstName,
      lastName,
      age,
      phone,
      suburb,
      gender,
      state: selectedState,
      postalCode,
    };

    // Persist profile immediately so going back retains data
    localStorage.setItem("userProfile", JSON.stringify(profileData));
  };

  const savePasswordData = async () => {
    if (hasExistingAccount) {
      localStorage.removeItem("userPassword");
      return;
    }
    // Here you would typically save to backend
    const passwordData = {
      password,
      confirmPassword,
    };

    // Persist password immediately so going back retains data
    localStorage.setItem("userPassword", JSON.stringify(passwordData));
  };

  const handleOtpVerification = async () => {
    try {
      const result = await dispatch(
        verifySignupOtp({
          email,
          otp: otp.join(""),
          restore: restoreMode,
        }),
      );
      if (result.payload?.success) {
        const draft = result.payload?.data?.draft;
        const profile = draft?.profile;
        const nextRestoreMode = result.payload?.data?.restoreMode === true;
        const verificationProof = result.payload?.data?.token || "";

        setRestoreMode(nextRestoreMode);
        let existingAccount = false;
        let accountRoles = [];
        if (!nextRestoreMode) {
          const emailCheck = await dispatch(
            emailVerification({ email }),
          ).unwrap();
          existingAccount = Boolean(emailCheck?.data);
          accountRoles = emailCheck?.roles || [];
        }
        setSignupProof(verificationProof);
        setExistingAccountRoles(accountRoles);
        setHasExistingAccount(existingAccount);
        if (existingAccount) setConfirmPassword("");
        if (nextRestoreMode) {
          localStorage.setItem("memberSetup.restoreMode", "true");
        } else {
          localStorage.removeItem("memberSetup.restoreMode");
        }

        if (profile) {
          setFirstName(profile.firstName || "");
          setLastName(profile.lastName || "");
          setAge(String(profile.age ?? ""));
          setPhone(profile.phone || "");
          setGender(
            profile.gender
              ? profile.gender.charAt(0).toUpperCase() + profile.gender.slice(1)
              : genderOptions[0],
          );
          pendingDraftSuburbRef.current = profile.suburb || "";
          setSelectedState(profile.state || "");
          setPostalCode(profile.postalCode || "");
          localStorage.setItem(
            "userProfile",
            JSON.stringify({
              firstName: profile.firstName || "",
              lastName: profile.lastName || "",
              age: String(profile.age ?? ""),
              phone: profile.phone || "",
              suburb: profile.suburb || "",
              gender: profile.gender || "",
              state: profile.state || "",
              postalCode: profile.postalCode || "",
            }),
          );
        } else {
          localStorage.removeItem("userProfile");
          localStorage.removeItem("userPassword");
          localStorage.removeItem("memberSetup.fund");
          resetMemberDraftState();
        }

        const resumeStep = draft?.currentStep === 2 ? 2 : 1;
        setStep(resumeStep);
        if (existingAccount && resumeStep === 2) {
          setShowLinkedAccountPasswordModal(true);
        }
        toast.success("Email verified successfully");
      } else {
        toast.error(result.payload?.message || "Invalid OTP");
      }
    } catch (error) {
      toast.error(error?.message || "OTP verification failed");
    }
  };

  const handleLinkedAccountPassword = async (existingPassword) => {
    await verifySignupExistingPassword({
      email,
      password: existingPassword,
      role: "member",
      proof: signupProof,
    });
    setPassword(existingPassword);
    setConfirmPassword(existingPassword);
    setShowLinkedAccountPasswordModal(false);
  };

  const handleUseDifferentMemberEmail = () => {
    clearMemberSetupProgress();
    resetMemberDraftState();
    setEmail("");
    setOtp(["", "", "", "", "", ""]);
    setSignupProof("");
    setExistingAccountRoles([]);
    setAwaitingOtp(false);
    setShowLinkedAccountPasswordModal(false);
    setStep(0);
    navigate("/member-setup", { replace: true, state: null });
  };

  const handleForgotLinkedAccountPassword = () => {
    navigate("/forget-password", {
      state: {
        signupResume: {
          role: "member",
          email,
          proof: signupProof,
          returnPath: "/member-setup",
          signupOtpCode: otp.join(""),
          resumeStep: step,
        },
      },
    });
  };

  const handleFundraiserCategoryChange = async (category) => {
    setFundCategory(category);
    setFundSubcat("");
    setFundSubcatIds([]);
    setFundName("");
    setFundraiserNameSearch("");
    setSelectedFundraiserId(null);
    dispatch(clearMemberFundraiserPickerData());

    const categoryData = categories?.find((c) => c.title === category);
    const catId = categoryData?._id || categoryData?.id;
    if (!MEMBER_FUNDRAISER_CATEGORIES_WITH_SUBCATEGORY.includes(category)) {
      await dispatch(
        getFundraisersByCategoryId({
          categoryId: catId,
          categoryTitle: category,
        }),
      );
      return;
    }

    if (catId) {
      await dispatch(getSubCategoriesByCategoryId({ id: catId }));
    }
  };

  const toggleSubCategory = async (subCategory) => {
    setFundName("");
    setSelectedFundraiserId(null);
    const subCategoryData = (subCategories || [])?.find(
      (s) => s.title === subCategory,
    );
    const subId = subCategoryData?._id || subCategoryData?.id;
    if (!subId) return;
    setFundSubcatIds((prev) => {
      const exists = prev.includes(subId);
      const next = exists
        ? prev.filter((id) => id !== subId)
        : [...prev, subId];
      const titles = (subCategories || [])
        .filter((s) => next.includes(s._id || s.id))
        .map((s) => s.title);
      setFundSubcat(titles.join(", "));
      dispatch(clearMemberFundraiserResults());
      // Debounce fetch to avoid multiple rapid requests
      if (next.length > 0) {
        clearTimeout(window.__SUBCAT_FETCH_TIMER__);
        window.__SUBCAT_FETCH_TIMER__ = setTimeout(() => {
          dispatch(getFundraisersBySubCategoryId({ subCategoryIds: next }));
        }, 250);
      }
      return next;
    });
  };

  const removeSubCategoryChip = (subId) => {
    setFundSubcatIds((prev) => {
      const next = prev.filter((id) => id !== subId);
      const titles = (subCategories || [])
        .filter((s) => next.includes(s._id || s.id))
        .map((s) => s.title);
      setFundSubcat(titles.join(", "));
      dispatch(clearMemberFundraiserResults());
      if (next.length > 0) {
        clearTimeout(window.__SUBCAT_FETCH_TIMER__);
        window.__SUBCAT_FETCH_TIMER__ = setTimeout(() => {
          dispatch(getFundraisersBySubCategoryId({ subCategoryIds: next }));
        }, 250);
      }
      return next;
    });
  };

  const handleFundraiserNameChange = async (name) => {
    setFundName(name);
    const cleaned = String(name || "").trim();
    if (!cleaned) {
      setSelectedFundraiserId(null);
      return;
    }

    const fundraiserData = (fundraisers || []).find((f) => {
      const rawLabel =
        f?.user?.name || f?.title || f?.name || f?.businessName || "";
      const label = String(rawLabel || "").trim();
      return label && label === cleaned;
    });

    const userId =
      fundraiserData?.user?._id || fundraiserData?._id || fundraiserData?.id;
    if (!userId) {
      // Ignore random typed text / Enter that doesn't map to an option.
      setFundName("");
      setSelectedFundraiserId(null);
      return;
    }

    setSelectedFundraiserId(userId);
    dispatch(getFundraiserContent({ userId }));
    // If user is already logged in (which they should be by step 3), try to update referral immediately
    if (getTokenData()) {
      dispatch(updateReferredBy({ referredBy: userId }))
        .unwrap()
        .catch(() => {});
    }
  };

  const blurActiveSelect = () => {
    setTimeout(() => {
      if (
        document?.activeElement &&
        typeof document.activeElement.blur === "function"
      ) {
        document.activeElement.blur();
      }
    }, 0);
  };

  const fundraiserOptions = (fundraisers || [])
    .map((f) => {
      const rawLabel =
        f?.user?.name || f?.title || f?.name || f?.businessName || "";
      const label = String(rawLabel || "").trim();
      if (!label) return null;
      const id = f?._id || f?.id || label;
      return { value: label, label, key: id };
    })
    .filter(Boolean)
    .sort((a, b) =>
      a.label.trim().toLowerCase().localeCompare(b.label.trim().toLowerCase()),
    );

  console.log("Invited email", invitedEmail);
  console.log("Email state", email);
  const handleProfileProceed = async () => {
    const isValid = validateProfileStep();
    if (!isValid) return;
    setProfileLoading(true);
    await saveProfileData();
    try {
      const payload = {
        email: (email || invitedEmail || "").trim(),
        restoreMode,
        firstName,
        lastName,
        age: parseInt(age, 10),
        phone,
        gender: gender.toLowerCase(),
        suburb,
        state: selectedState,
        postalCode,
      };
      await dispatch(saveMemberSignupDraft(payload)).unwrap();
      setStep(2);
      if (hasExistingAccount) setShowLinkedAccountPasswordModal(true);
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to save your signup progress.";
      if (String(message).toLowerCase().includes("already exists")) {
        clearMemberSetupProgress();
        setAwaitingOtp(false);
        setOtp(["", "", "", "", "", ""]);
        setStep(0);
        toast.error(
          "This email is already registered. Please log in to continue.",
        );
        return;
      }
      toast.error(message);
    } finally {
      setProfileLoading(false);
    }
  };

  const handlePasswordProceed = async () => {
    const isValid = validatePasswordStep();
    if (!isValid) return;
    await savePasswordData();
    try {
      const fullName = `${firstName || ""} ${lastName || ""}`.trim() || email;
      const verificationCode = otp.join("");
      const signupEmail = (email || invitedEmail || "").trim();
      const isValidEmail = /[^\s@]+@[^\s@]+\.[^\s@]+/.test(signupEmail);
      if (isValidEmail) {
        const payload = {
          name: fullName,
          password,
          code: verificationCode,
          email: signupEmail,
          restoreMode,
          age: parseInt(age, 10),
          phone,
          gender: gender.toLowerCase(),
          suburb,
          state: selectedState,
          postalCode,
        };
        const signUpResult = await dispatch(signUp(payload)).unwrap();
        if (!signUpResult?.success) {
          throw new Error(signUpResult?.message || "Unable to complete signup.");
        }
        await dispatch(
          login({ email: signupEmail, password, role: "member" }),
        ).unwrap();
        await new Promise((r) => setTimeout(r, 500));
        localStorage.removeItem("memberSetup.restoreMode");
        setRestoreMode(false);
      }
    } catch (error) {
      toast.error(
        error?.message || "Unable to complete signup. Please try again.",
      );
      return;
    }
    setStep(3);
  };

  const handleCheckoutProceed = async () => {
    try {
      let nextSelectedPlan = selectedPlan;
      let nextSubscriptionPlans = subscriptionPlans;
      let priceId =
        nextSelectedPlan?.priceId || nextSubscriptionPlans?.[0]?.priceId;

      if (!priceId) {
        try {
          const result = await dispatch(getSubscriptionPlans({})).unwrap();
          if (result?.success === true && Array.isArray(result?.data)) {
            nextSubscriptionPlans = result.data;
            setSubscriptionPlans(result.data);

            if (!nextSelectedPlan && result.data.length > 0) {
              nextSelectedPlan = result.data[0];
              setSelectedPlan(result.data[0]);
            }

            priceId =
              nextSelectedPlan?.priceId || nextSubscriptionPlans?.[0]?.priceId;
          }
        } catch (planError) {
          console.error("Unable to refresh subscription plans", planError);
        }
      }

      if (!priceId) {
        toast.error("Subscription plans unavailable. Please try again later.");
        return;
      }
      try {
        if (!getTokenData()) {
          const loginEmail = (email || invitedEmail || "").trim();
          if (loginEmail && password) {
            await dispatch(
              login({ email: loginEmail, password, role: "member" }),
            ).unwrap();
            await new Promise((r) => setTimeout(r, 500));
          }
        }
      } catch (loginErr) {
        console.error("Background login failed", loginErr);
      }
      if (selectedFundraiserId) {
        dispatch(
          updateReferredBy({ referredBy: String(selectedFundraiserId) }),
        );
      } else if (fundName) {
        const fundraiserData = (fundraisers || []).find(
          (c) => (c?.user?.name || c?.title || c?.name) === fundName,
        );
        const fid =
          fundraiserData?.user?._id ||
          fundraiserData?._id ||
          fundraiserData?.id;
        if (fid) dispatch(updateReferredBy({ referredBy: String(fid) }));
      }
      const customerEmail = (email || invitedEmail || "").trim();
      const data = await dispatch(
        checkout({
          priceId: String(priceId),
          email: customerEmail,
          referredBy: selectedFundraiserId
            ? String(selectedFundraiserId)
            : undefined,
        }),
      ).unwrap();
      const url =
        data?.data?.url || data?.url || data?.sessionUrl || data?.session?.url;
      if (url) {
        window.location.replace(url);
      } else {
        toast.error("Checkout session not available. Please try again.");
      }
    } catch (e) {
      console.error("Checkout error", e);
      toast.error("Unable to process checkout. Please try again.");
    }
  };

  const handleNotifyMe = async (e) => {
    if (e) e.preventDefault();
    if (!waitlistPhone || waitlistPhone.trim().length <= 4) {
      toast.error("Please enter a valid mobile number.");
      return;
    }

    setWaitlistLoading(true);
    try {
      const response = await axios.post("waitlist/member", {
        phone: waitlistPhone.trim(),
      });

      if (response.data?.success) {
        setComingSoonScreen(2);
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      toast.error(err.message || "Failed to submit. Please try again.");
    } finally {
      setWaitlistLoading(false);
    }
  };

  const handleWaitlistSubmit = async (e) => {
    if (e) e.preventDefault();
    if (isSubmitDisabled) return;

    setWaitlistLoading(true);
    try {
      const response = await axios.post("waitlist/member", {
        phone: waitlistPhone.trim(),
        surveyAnswers: {
          offersFeedback: offersFeedback.trim(),
          brandsFeedback: brandsFeedback.trim(),
          referralSource: referralSource,
          generalFeedback: generalFeedback.trim(),
        },
      });

      if (response.data?.success) {
        setIsSubmitDisabled(true);
        toast.success("Thank you! Your feedback has been saved.");
        setTimeout(() => {
          dispatch(clearAuth());
          clearMemberSetupProgress();
          window.location.href = "https://www.swoodle.com.au";
        }, 1500);
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      toast.error(err.message || "Failed to submit. Please try again.");
    } finally {
      setWaitlistLoading(false);
    }
  };

  const handleReturnToLogin = () => {
    dispatch(clearAuth());
    clearMemberSetupProgress();
    window.location.href = "https://www.swoodle.com.au";
  };

  const onGlobalSubmit = async (e) => {
    if (e) e.preventDefault();
    if (step === 0) {
      if (awaitingOtp) {
        if (otp.join("").length === 6 && !authLoading) handleOtpVerification();
      } else {
        if (email && !authLoading) handleEmailVerification();
      }
    } else if (step === 1) {
      if (!profileLoading) handleProfileProceed();
    } else if (step === 2) {
      if (!authLoading) handlePasswordProceed();
    } else if (step === 3) {
      if (comingSoonScreen === 1) {
        if (!waitlistLoading) handleNotifyMe();
      } else if (comingSoonScreen === 2) {
        if (!waitlistLoading) handleWaitlistSubmit();
      }
    }
  };

  return (
    <>
    <form onSubmit={onGlobalSubmit}>
      <div className="min-h-screen bg-white pb-32">
        <div className="px-6 pt-3 pb-4 relative z-10 bg-white overflow-hidden">
          {/* Stepper above logo */}
          <div className="flex items-end justify-between mb-3">
            {[
              { key: 0, label: "Email" },
              { key: 1, label: "Profile" },
              { key: 2, label: "Password" },
              { key: 3, label: "Coming Soon" },
            ].map((s) => (
              <div key={s.key} className="flex-1 min-w-0 px-1">
                <div
                  className={`h-[2px] ${step >= s.key ? "bg-[#00ADEF]" : "bg-[#E6E6E6]"}`}
                  style={{ width: 72 }}
                />
                <div
                  className={`mt-1 text-[12px] font-[600] font-poppins text-left truncate ${step >= s.key ? "text-[#00ADEF]" : "text-[#8C8C8C]"}`}
                >
                  {s.label}
                </div>
              </div>
            ))}
          </div>
          <img
            src={SwoodleLogo}
            className="w-[160px] h-auto block"
            alt="SWOODLE"
          />
          <div className="absolute right-0 top-0 h-full w-3 bg-white" />
        </div>

        <div className="px-6">
          {step === 0 && !awaitingOtp && (
            <div className="text-left mb-5">
              <h2 className="text-[28px] font-[700] font-poppins text-[#303030] mb-3">
                Get Started
              </h2>
              <p className="text-[16px] font-[400] font-poppins text-[#8C8C8C]">
                Enter your email to create your account.
              </p>
            </div>
          )}

          <div className="space-y-6">
            {step === 0 && (
              <div>
                {!awaitingOtp && (
                  <>
                    <label className="block text-[14px] font-[600] font-poppins text-[#303030] mb-3">
                      Email address
                    </label>
                    <div className="h-[64px]">
                      <input
                        type="email"
                        name="email"
                        ref={emailInputRef}
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setHasExistingAccount(false);
                          setConfirmPassword("");
                          setEmailExists("");
                        }}
                        placeholder="Enter your email"
                        className="w-full h-full px-3 rounded-[8px] border border-[#EFF2F5] bg-[#F3F6F9] outline-none text-[16px] font-poppins"
                        autoComplete="email"
                        inputMode="email"
                        autoCapitalize="off"
                        autoCorrect="off"
                      />
                    </div>
                    {emailExists && (
                      <div
                        role="alert"
                        className="mt-2 flex items-center gap-2 text-[12px] text-[#D92D20]"
                      >
                        <BsInfoCircle className="w-[14px] h-[14px] text-[#D92D20]" />
                        <span>{emailExists}</span>
                      </div>
                    )}
                  </>
                )}

                {awaitingOtp && (
                  <>
                    <p className="text-[16px] font-[700] font-poppins text-[#303030] mt-2 mb-1">
                      Check your email
                    </p>
                    <p className="text-[12px] font-poppins text-[#8C8C8C] mb-3">
                      To confirm your email address, please enter the OTP we
                      sent to {email}
                    </p>
                    <div className="flex items-center gap-3">
                      {otp.map((d, i) => (
                        <React.Fragment key={i}>
                          <input
                            ref={otpRefs[i]}
                            type="text"
                            inputMode="numeric"
                            maxLength={1}
                            className="w-[44px] h-[44px] rounded-[8px] bg-[#F3F6F9] border border-[#EFF2F5] text-center text-[14px] font-[600]"
                            value={otp[i]}
                            onChange={(e) => handleOtpInputChange(e, i)}
                            onKeyDown={(e) => {
                              if (e.key === "Backspace" && !otp[i] && i > 0)
                                otpRefs[i - 1].current?.focus();
                            }}
                            onPaste={i === 0 ? handleOtpPaste : undefined}
                          />
                          {i === 2 && (
                            <span className="mx-1 text-[#CFCFCF]">-</span>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                    {canResend ? (
                      <p className="text-[13px] font-poppins text-[#303030] mt-4">
                        Don't Receive Code?{" "}
                        <button
                          type="button"
                          onClick={async () => {
                            try {
                              const result = await dispatch(
                                sendSignupOtp({ email, role: "member" }),
                              );
                              if (result.payload?.success) {
                                setCanResend(false);
                                setOtpTimeLeft(60);
                                setOtp(["", "", "", "", "", ""]);
                                toast.success("OTP resent to your email");
                              } else {
                                toast.error(
                                  result.payload?.message ||
                                    "Failed to resend OTP",
                                );
                              }
                            } catch (error) {
                              toast.error("Failed to resend OTP");
                            }
                          }}
                          className="text-[#00ADEF] underline font-[600]"
                        >
                          Resend Code
                        </button>
                      </p>
                    ) : (
                      <p className="text-[12px] font-poppins text-[#303030] mt-4">
                        Resend code on{" "}
                        {String(Math.floor(otpTimeLeft / 60)).padStart(2, "0")}:
                        {String(otpTimeLeft % 60).padStart(2, "0")}
                      </p>
                    )}
                  </>
                )}
              </div>
            )}

            {step === 0 && (
              <div className="pt-8">
                {awaitingOtp ? (
                  <div
                    className="flex justify-between fixed left-0 right-0 bottom-5 px-6 z-50 bg-white pt-4"
                    style={{ boxShadow: "0 -1px 0 #E6E6E6" }}
                  >
                    <PrimaryButton
                      type="button"
                      label="Back"
                      onClick={() => setAwaitingOtp(false)}
                      className="w-[48%] h-[52px] rounded-[10px] bg-white text-[#A6A6A6] border border-[#CFCFCF] font-[600]"
                    />
                    <PrimaryButton
                      type="submit"
                      disabled={otp.join("").length !== 6 || authLoading}
                      label="Next"
                      loading={authLoading}
                      className="w-[48%] h-[52px] rounded-[10px] text-[16px] font-[600]"
                    />
                  </div>
                ) : (
                  <div
                    className="flex justify-center fixed left-0 right-0 bottom-5 px-6 z-50 bg-white pt-4"
                    style={{ boxShadow: "0 -1px 0 #E6E6E6" }}
                  >
                    <PrimaryButton
                      type="submit"
                      label="Next"
                      loading={authLoading}
                      className="w-full h-[52px] rounded-[8px] text-[16px] font-[600]"
                      disabled={!email || authLoading}
                    />
                  </div>
                )}
              </div>
            )}

            {step === 1 && (
              <div className="mt-0">
                <h3 className="text-[20px] font-[700] font-poppins text-[#303030] mb-1">
                  Complete Your Profile
                </h3>
                <p className="text-[13px] font-poppins text-[#8C8C8C] mb-4">
                  Add your details to personalise your account.
                </p>

                <div className="relative mb-3">
                  <label className="block text-[14px] font-[600] font-poppins text-[#303030] mb-2">
                    First name
                  </label>
                  <div className="h-[48px]">
                    <input
                      value={firstName}
                      onChange={(e) => {
                        const v = e.target.value;
                        setFirstName(v);
                        setNameErrors((s) => ({ ...s, first: false }));
                        if (fieldErrors.firstName)
                          setFieldErrors((prev) => ({
                            ...prev,
                            firstName: "",
                          }));
                      }}
                      onBlur={() => setFirstName((v) => v.trim())}
                      placeholder="John"
                      className={`w-full h-full px-3 rounded-[8px] border ${nameErrors.first ? "border-red-400" : "border-[#EFF2F5]"} bg-[#F3F6F9] outline-none text-[16px] font-poppins`}
                    />
                  </div>
                  {fieldErrors.firstName && (
                    <p className="text-[12px] text-red-500 mt-2">
                      {fieldErrors.firstName}
                    </p>
                  )}
                  {nameErrors.first && !fieldErrors.firstName && (
                    <p className="text-[12px] text-red-500 mt-2">
                      Please enter letters only
                    </p>
                  )}
                </div>

                <div className="relative mb-3">
                  <label className="block text-[14px] font-[600] font-poppins text-[#303030] mb-2">
                    Last name
                  </label>
                  <div className="h-[48px]">
                    <input
                      value={lastName}
                      onChange={(e) => {
                        const v = e.target.value;
                        setLastName(v);
                        setNameErrors((s) => ({ ...s, last: false }));
                        if (fieldErrors.lastName)
                          setFieldErrors((prev) => ({
                            ...prev,
                            lastName: "",
                          }));
                      }}
                      onBlur={() => setLastName((v) => v.trim())}
                      placeholder="Smith"
                      className={`w-full h-full px-3 rounded-[8px] border ${nameErrors.last ? "border-red-400" : "border-[#EFF2F5]"} bg-[#F3F6F9] outline-none text-[16px] font-poppins`}
                    />
                  </div>
                  {fieldErrors.lastName && (
                    <p className="text-[12px] text-red-500 mt-2">
                      {fieldErrors.lastName}
                    </p>
                  )}
                  {nameErrors.last && !fieldErrors.lastName && (
                    <p className="text-[12px] text-red-500 mt-2">
                      Please enter letters only
                    </p>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-3 mb-3">
                  <div className="relative" ref={genderRef}>
                    <label className="block text-[14px] font-[600] font-poppins text-[#303030] mb-2">
                      Gender
                    </label>
                    <button
                      type="button"
                      onClick={() => setGenderOpen((s) => !s)}
                      className="w-full h-[48px] px-3 rounded-[8px] border border-[#EFF2F5] bg-[#F3F6F9] text-left text-[16px] font-poppins flex items-center justify-between"
                    >
                      <span>{gender}</span>
                      <svg
                        className={`w-5 h-5 text-[#303030] transition-transform ${genderOpen ? "rotate-180" : ""}`}
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.08z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                    <div
                      className={`absolute left-0 right-0 mt-2 origin-top transition-all duration-200 ${genderOpen ? "opacity-100 scale-y-100" : "opacity-0 scale-y-0 pointer-events-none"} bg-white border border-[#EFF2F5] rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.08)] z-[70]`}
                    >
                      <div className="max-h-[200px] overflow-auto py-2">
                        {genderOptions.map((g) => (
                          <button
                            key={g}
                            type="button"
                            onClick={() => {
                              setGender(g);
                              setGenderOpen(false);
                            }}
                            className={`w-full text-left px-3 py-3 text-[16px] font-poppins hover:bg-[#F3F6F9] ${g === gender ? "bg-[#EAF7FF] text-[#00ADEF]" : "text-[#303030]"}`}
                          >
                            {g}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className="block text-[14px] font-[600] font-poppins text-[#303030] mb-2">
                      Age
                    </label>
                    <div className="h-[48px]">
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={age}
                        onChange={(e) => {
                          const val = e.target.value.replace(/[^0-9]/g, "");
                          if (val.length <= 2) {
                            setAge(val);
                            setFieldErrors((s) => ({ ...s, age: "" }));
                          }
                        }}
                        onBlur={() => {
                          const val = parseInt(age, 10);
                          if (age && (val < 5 || val > 95)) {
                            setFieldErrors((s) => ({
                              ...s,
                              age: "Age must be between 5 and 95",
                            }));
                          }
                        }}
                        placeholder="23"
                        className={`w-full h-full px-3 rounded-[8px] border ${fieldErrors.age ? "border-red-400" : "border-[#EFF2F5]"} bg-[#F3F6F9] outline-none text-[16px] font-poppins`}
                      />
                    </div>
                    {fieldErrors.age && (
                      <p className="text-[12px] text-red-500 mt-2">
                        {fieldErrors.age}
                      </p>
                    )}
                  </div>
                </div>

                <div className="relative mb-3">
                  <label className="block text-[14px] font-[600] font-poppins text-[#303030] mb-2">
                    Phone number
                  </label>
                  <div className="h-[48px] member-setup-phone-input">
                    <PhoneInput
                      country={"au"}
                      separateDialCode={true}
                      value={phone}
                      onChange={(value, countryData) => {
                        setPhoneCountry(countryData?.countryCode || "au");
                        const format = countryData?.format || "";
                        const dotCount = (format.match(/\./g) || []).length;
                        const limit = dotCount > 0 ? dotCount : 15;
                        const cleanVal = String(value || "").replace(/\D/g, "");
                        const formattedPhone = cleanVal ? ("+" + cleanVal) : "";
                        const formattedLimit = cleanVal ? (limit + 1) : 15;
                        if (formattedPhone.length > formattedLimit) {
                          setPhone(formattedPhone.slice(0, formattedLimit));
                        } else {
                          setPhone(formattedPhone);
                        }
                      }}
                      placeholder="412 345 678"
                      inputStyle={{
                        width: "100%",
                        height: "48px",
                        background: "#F3F6F9",
                        border: "1px solid #EFF2F5",
                        borderRadius: 8,
                        paddingLeft: 48,
                        fontFamily: "Poppins, sans-serif",
                        fontSize: 16,
                        color: "#303030",
                      }}
                      buttonStyle={{
                        background: "#F3F6F9",
                        border: "none",
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        width: 40,
                        paddingLeft: 0,
                      }}
                      dropdownStyle={{ borderRadius: 8 }}
                    />
                  </div>
                  {fieldErrors.phone && (
                    <p className="text-[12px] text-red-500 mt-2">
                      {fieldErrors.phone}
                    </p>
                  )}
                </div>

                {/* State dropdown */}
                <div className="relative mb-3">
                  <SearchableSelect
                    variant="mobile"
                    label="State"
                    placeholder="Select state"
                    options={stateOptions}
                    value={selectedState}
                    onChange={(val) => {
                      setSelectedState(val || "");
                      if (fieldErrors.selectedState)
                        setFieldErrors((prev) => ({
                          ...prev,
                          selectedState: "",
                        }));
                    }}
                    error={fieldErrors.selectedState}
                  />
                </div>

                {/* Suburb dropdown (Searchable inside) */}
                <div className="relative mb-3">
                  <SearchableSelect
                    variant="mobile"
                    label="Suburb"
                    placeholder={
                      selectedState ? "Select suburb" : "Select state first"
                    }
                    options={selectedState ? suburbOptions : []}
                    virtual={true}
                    value={suburb}
                    disabled={!selectedState || suburbLoading}
                    loading={suburbLoading}
                    onChange={(val) => {
                      setSuburb(val || "");
                      if (fieldErrors.suburb)
                        setFieldErrors((prev) => ({ ...prev, suburb: "" }));
                    }}
                    error={fieldErrors.suburb}
                  />
                </div>

                {/* Postal Code input */}
                <div className="relative mb-3">
                  <label className="block text-[14px] font-[600] font-poppins text-[#303030] mb-2">
                    Postal Code{" "}
                    <span className="text-[#8C8C8C] font-[400] text-[12px] ml-1">
                      (Optional)
                    </span>
                  </label>
                  <div className="h-[48px]">
                    <input
                      type="text"
                      placeholder="3000"
                      value={postalCode}
                      onChange={(e) => {
                        const cleaned = String(e.target.value || "")
                          .replace(/[^0-9]/g, "")
                          .slice(0, 4);
                        setPostalCode(cleaned);
                        if (fieldErrors.postalCode)
                          setFieldErrors((prev) => ({
                            ...prev,
                            postalCode: "",
                          }));
                      }}
                      className={`w-full h-full px-3 rounded-[8px] border ${fieldErrors.postalCode ? "border-red-400" : "border-[#EFF2F5]"} bg-[#F3F6F9] outline-none text-[16px] font-poppins`}
                    />
                  </div>
                  {fieldErrors.postalCode && (
                    <p className="text-[12px] text-red-500 mt-2">
                      {fieldErrors.postalCode}
                    </p>
                  )}
                </div>

                <div
                  className="flex justify-between fixed left-0 right-0 bottom-5 px-6 z-50 bg-white pt-4"
                  style={{ boxShadow: "0 -1px 0 #E6E6E6" }}
                >
                  <PrimaryButton
                    type="button"
                    label="Back"
                    onClick={() => setStep(0)}
                    className="w-[48%] h-[52px] rounded-[10px] bg-white text-[#A6A6A6] border border-[#CFCFCF] font-[600]"
                  />
                  <PrimaryButton
                    type="submit"
                    label="Next"
                    loading={profileLoading}
                    className="w-[48%] h-[52px] rounded-[10px] text-[16px] font-[600]"
                  />
                </div>
              </div>
            )}

            {step === 2 && (
              <div className="mt-2">
                <h3 className="text-[20px] font-[700] font-poppins text-[#303030] mb-1">
                  Secure Your Account
                </h3>
                <p className="text-[13px] font-poppins text-[#8C8C8C] mb-5">
                  {hasExistingAccount
                    ? "This email already has a Swoodle account. Enter its password to continue creating your Member account."
                    : "Create a strong password to protect your account."}
                </p>
                <label className="block text-[14px] font-[600] font-poppins text-[#303030] mb-2">
                  Password
                </label>
                <div className="h-[48px] mb-2 relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onBlur={validatePasswordOnly}
                    readOnly={hasExistingAccount}
                    minLength={8}
                    placeholder="••••••••"
                    className="w-full h-full pr-10 pl-3 rounded-[8px] border border-[#EFF2F5] bg-[#F3F6F9] outline-none text-[16px] font-poppins"
                  />
                  <button
                    type="button"
                    aria-label="Toggle password visibility"
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8C8C8C] z-10 w-7 h-7 flex items-center justify-center"
                    onClick={() => setShowPassword((s) => !s)}
                  >
                    {showPassword ? (
                      // eye (when password is visible, show eye icon to indicate you can hide it)
                      <svg
                        className="w-5 h-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12z"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <circle
                          cx="12"
                          cy="12"
                          r="3"
                          stroke="currentColor"
                          strokeWidth="1.8"
                        />
                      </svg>
                    ) : (
                      // eye-off (when password is hidden, show eye-slash icon to indicate you can show it)
                      <svg
                        className="w-5 h-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3 3l18 18"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M10.5 6.2A9.7 9.7 0 0112 6c6 0 10 6 10 6s-.62 1.05-1.82 2.33M6.82 6.82C4.64 8.25 3 10 3 12c0 0 4 6 10 6 1.03 0 2-.16 2.9-.46"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M9.88 9.88A3 3 0 0012 15a3 3 0 002.12-.88"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                {fieldErrors.password && (
                  <p className="text-[12px] text-red-500 mb-2">
                    {fieldErrors.password}
                  </p>
                )}
                <p className="text-[11px] text-[#8C8C8C] mb-4">
                  Hint: 8+ characters, 1 number, 1 special character
                </p>
                {!hasExistingAccount && (
                  <label className="block text-[14px] font-[600] font-poppins text-[#303030] mb-2">
                  Confirm Password
                  </label>
                )}
                <div
                  className={`h-[48px] mb-6 relative ${
                    hasExistingAccount ? "hidden" : ""
                  }`}
                >
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    onBlur={validateConfirmOnly}
                    minLength={8}
                    placeholder="••••••••"
                    className="w-full h-full pr-10 pl-3 rounded-[8px] border border-[#EFF2F5] bg-[#F3F6F9] outline-none text-[16px] font-poppins"
                  />
                  <button
                    type="button"
                    aria-label="Toggle confirm password visibility"
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8C8C8C] z-10 w-7 h-7 flex items-center justify-center"
                    onClick={() => setShowConfirmPassword((s) => !s)}
                  >
                    {showConfirmPassword ? (
                      // eye (when password is visible, show eye icon to indicate you can hide it)
                      <svg
                        className="w-5 h-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12z"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <circle
                          cx="12"
                          cy="12"
                          r="3"
                          stroke="currentColor"
                          strokeWidth="1.8"
                        />
                      </svg>
                    ) : (
                      // eye-off (when password is hidden, show eye-slash icon to indicate you can show it)
                      <svg
                        className="w-5 h-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3 3l18 18"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M10.5 6.2A9.7 9.7 0 0112 6c6 0 10 6 10 6s-.62 1.05-1.82 2.33M6.82 6.82C4.64 8.25 3 10 3 12c0 0 4 6 10 6 1.03 0 2-.16 2.9-.46"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M9.88 9.88A3 3 0 0012 15a3 3 0 002.12-.88"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                {!hasExistingAccount && fieldErrors.confirmPassword && (
                  <p className="text-[12px] text-red-500 mb-6">
                    {fieldErrors.confirmPassword}
                  </p>
                )}
                <div
                  className="flex justify-between fixed left-0 right-0 bottom-5 px-6 z-50 bg-white pt-4"
                  style={{ boxShadow: "0 -1px 0 #E6E6E6" }}
                >
                  <PrimaryButton
                    type="button"
                    label="Back"
                    onClick={() => setStep(1)}
                    className="w-[48%] h-[52px] rounded-[10px] bg-white text-[#A6A6A6] border border-[#CFCFCF] font-[600]"
                  />
                  <PrimaryButton
                    type="submit"
                    label="Next"
                    loading={authLoading}
                    className="w-[48%] h-[52px] rounded-[10px] text-[16px] font-[600]"
                  />
                </div>
              </div>
            )}

            {step === 3 && checkingSubscription ? (
              <div className="mt-2 text-center font-poppins">
                <div
                  className="bg-white rounded-[16px] shadow-[0_8px_24px_rgba(0,0,0,0.08)] p-6 border border-[#EFF2F5] flex flex-col items-center justify-center gap-4"
                  style={{ minHeight: "250px" }}
                >
                  <div className="w-10 h-10 border-4 border-[#13A0E1] border-t-transparent rounded-full animate-spin"></div>
                  <p className="text-[13px] text-[#6B6B6B]">
                    Checking your membership status...
                  </p>
                </div>
              </div>
            ) : step === 3 && activeSubscription ? (
              <div className="mt-2 text-center font-poppins">
                <div className="bg-white rounded-[16px] shadow-[0_8px_24px_rgba(0,0,0,0.08)] p-6 border border-[#EFF2F5] flex flex-col items-center gap-5">
                  <div className="w-[70px] h-[70px] rounded-full bg-[#EAF7FF] flex items-center justify-center text-[#13A0E1]">
                    <svg
                      width="34"
                      height="34"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 12l2 2 4-4"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                    </svg>
                  </div>

                  <div className="space-y-2">
                    <h3 className="text-[20px] font-[700] text-[#303030]">
                      Welcome back to Swoodle!
                    </h3>
                    <p className="text-[13px] text-[#6B6B6B] leading-relaxed">
                      Good news, your active membership from your previous
                      account has been transferred and remains valid until{" "}
                      <span className="font-[700] text-[#13A0E1]">
                        {activeSubscription?.subscriptionExpiryTime
                          ? new Date(
                              activeSubscription.subscriptionExpiryTime,
                            ).toLocaleDateString("en-AU", {
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                            })
                          : ""}
                      </span>
                      .
                    </p>
                    <p className="text-[13px] text-[#6B6B6B] leading-relaxed">
                      Enjoy all the great deals, exclusive offers, and savings
                      that come with being a Swoodle member.
                    </p>
                  </div>

                  <PrimaryButton
                    type="button"
                    label="Go to My Account"
                    onClick={() => {
                      sessionStorage.setItem("fromRestoreFlow", "true");
                      window.location.href = "/existing-subscription";
                    }}
                    className="w-full max-w-[280px] h-[48px] rounded-[8px] mt-2 font-[600]"
                  />
                </div>
              </div>
            ) : step === 3 ? (
              <div className="mt-2">
                {/* Coming Soon Screen 1: Mobile Number Input */}
                {comingSoonScreen === 1 && (
                  <div className="coming-soon-page-embedded flex flex-col gap-8 text-center font-poppins px-2">
                    <div className="text-center flex flex-col gap-4">
                      <h1 className="coming-soon-title text-[#00ADEF] font-poppins font-extrabold tracking-tight">
                        We're launching soon!
                      </h1>
                      <p className="coming-soon-subtitle text-gray-500 text-[14px] leading-relaxed font-poppins font-light">
                        Thanks for checking out Swoodle. We're putting the
                        finishing touches on the platform. Leave your mobile
                        number below and we'll send you a message as soon as we
                        go live.
                      </p>
                    </div>

                    <div className="form-group flex flex-col gap-2 text-left w-full">
                      <label
                        htmlFor="phone"
                        className="text-sm font-semibold text-[#08264a] font-poppins"
                      >
                        Mobile Number <span className="text-red-500">*</span>
                      </label>
                      <PhoneInput
                        country={"au"}
                        enableSearch
                        countryCodeEditable={false}
                        value={waitlistPhone}
                        onChange={(value, countryData) => {
                          const format = countryData?.format || "";
                          const dotCount = (format.match(/\./g) || []).length;
                          const limit = dotCount > 0 ? dotCount : 15;
                          const cleanVal = String(value || "").replace(/\D/g, "");
                          if (cleanVal.length > limit) {
                            setWaitlistPhone(cleanVal.slice(0, limit));
                          } else {
                            setWaitlistPhone(cleanVal);
                          }
                          setIsSubmitDisabled(false);
                        }}
                        placeholder="e.g. +61 400 000 000"
                        inputStyle={{
                          width: "100%",
                          height: "48px",
                          background: "#FFFFFF",
                          border: "1.5px solid #dcdfe4",
                          borderRadius: 12,
                          paddingLeft: 56,
                          fontFamily: "Poppins, sans-serif",
                          fontSize: 15,
                          color: "#2d3748",
                        }}
                        buttonStyle={{
                          background: "transparent",
                          border: "none",
                          borderTopLeftRadius: 12,
                          borderBottomLeftRadius: 12,
                          width: 44,
                          paddingLeft: 8,
                        }}
                        dropdownStyle={{ borderRadius: 8 }}
                      />
                    </div>

                    <div className="w-full mt-4">
                      <PrimaryButton
                        type="button"
                        label="Notify Me"
                        loading={waitlistLoading}
                        onClick={handleNotifyMe}
                        className="notify-button w-full py-4 rounded-xl text-white font-poppins font-bold text-base transition-all h-[52px]"
                      />
                    </div>
                  </div>
                )}

                {/* Coming Soon Screen 2: Questionnaire */}
                {comingSoonScreen === 2 && (
                  <div className="coming-soon-page-embedded flex flex-col gap-6 font-poppins px-1">
                    <div className="text-center flex flex-col gap-2">
                      <h1 className="coming-soon-title text-[#00ADEF] font-poppins font-extrabold tracking-tight">
                        We're launching soon!
                      </h1>
                    </div>

                    <div className="survey-section flex flex-col gap-6 bg-white rounded-3xl p-6 border border-[#d8e2ec] shadow-md">
                      <div className="text-left">
                        <h2 className="survey-heading text-md font-bold text-[#08264a] font-poppins">
                          Help Shape Swoodle (Quick Survey){" "}
                          <span className="text-[#00ADEF] font-[600] text-[13px] ml-1.5">
                            (Optional)
                          </span>
                        </h2>
                        <p className="text-[12px] text-gray-400 font-poppins mt-1">
                          Your feedback will help us partner with your favorite
                          local brands and customise our deals!
                        </p>
                      </div>

                      {/* Q1 */}
                      <div className="form-group flex flex-col gap-2">
                        <label
                          htmlFor="q1"
                          className="text-[13px] font-semibold text-[#08264a] font-poppins"
                        >
                          1. What types of offers or deals would you like to see
                          on Swoodle?
                        </label>
                        <textarea
                          id="q1"
                          rows="2"
                          placeholder="e.g., Buy-one-get-one dining, gym memberships, local groceries..."
                          value={offersFeedback}
                          onChange={(e) => {
                            setOffersFeedback(e.target.value);
                            setIsSubmitDisabled(false);
                          }}
                          className="survey-textarea w-full px-4 py-3 border border-[#D9D9D9] rounded-xl font-poppins resize-none focus:outline-none focus:border-[#007aff]"
                        />
                      </div>

                      {/* Q2 */}
                      <div className="form-group flex flex-col gap-2">
                        <label
                          htmlFor="q2"
                          className="text-[13px] font-semibold text-[#08264a] font-poppins"
                        >
                          2. Which brands, businesses, or services would you
                          like us to partner with?
                        </label>
                        <textarea
                          id="q2"
                          rows="2"
                          placeholder="e.g., Local cafes, retail chains, fitness centers..."
                          value={brandsFeedback}
                          onChange={(e) => {
                            setBrandsFeedback(e.target.value);
                            setIsSubmitDisabled(false);
                          }}
                          className="survey-textarea w-full px-4 py-3 border border-[#D9D9D9] rounded-xl font-poppins resize-none focus:outline-none focus:border-[#007aff]"
                        />
                      </div>

                      {/* Q3 */}
                      <div className="form-group flex flex-col gap-2">
                        <label
                          htmlFor="q3"
                          className="text-[13px] font-semibold text-[#08264a] font-poppins"
                        >
                          3. How did you hear about us?
                        </label>
                        <select
                          id="q3"
                          value={referralSource}
                          onChange={(e) => {
                            setReferralSource(e.target.value);
                            setIsSubmitDisabled(false);
                          }}
                          className="survey-select w-full px-4 py-3 border border-[#D9D9D9] rounded-xl font-poppins bg-white focus:outline-none focus:border-[#007aff]"
                        >
                          <option value="" disabled>
                            Select an option
                          </option>
                          <option value="Social Media">Social Media</option>
                          <option value="Friend or Family">
                            Friend or Family
                          </option>
                          <option value="Fundraiser Invitation">
                            Fundraiser Invitation
                          </option>
                          <option value="Online Search">Online Search</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>

                      {/* Q4 */}
                      <div className="form-group flex flex-col gap-2">
                        <label
                          htmlFor="q4"
                          className="text-[13px] font-semibold text-[#08264a] font-poppins"
                        >
                          4. Is there anything else you'd like to see on the
                          platform?
                        </label>
                        <textarea
                          id="q4"
                          rows="2"
                          placeholder="Describe any other features or feedback..."
                          value={generalFeedback}
                          onChange={(e) => {
                            setGeneralFeedback(e.target.value);
                            setIsSubmitDisabled(false);
                          }}
                          className="survey-textarea w-full px-4 py-3 border border-[#D9D9D9] rounded-xl font-poppins resize-none focus:outline-none focus:border-[#007aff]"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col gap-3 mt-2">
                      <PrimaryButton
                        type="button"
                        label="Submit"
                        disabled={isSubmitDisabled}
                        loading={waitlistLoading}
                        onClick={handleWaitlistSubmit}
                        className="w-full h-[52px] rounded-[10px] text-[16px] font-[600]"
                      />
                      <PrimaryButton
                        type="button"
                        label="Return to Main login screen"
                        onClick={handleReturnToLogin}
                        className="w-full h-[52px] rounded-[10px] text-[16px] font-[600]"
                      />
                    </div>
                  </div>
                )}

                {/* Commented Out Subscription Flow for Easy Live Activation
                <div className="bg-white rounded-[16px] shadow-[0_8px_24px_rgba(0,0,0,0.08)] p-5 border border-[#EFF2F5]">
                  <div className="flex items-end gap-1">
                    <span className="text-[28px] font-[800] text-[#303030]">
                      $49.99
                    </span>
                    <span className="text-[14px] text-[#303030] font-poppins">
                      /year
                    </span>
                  </div>
                  <div className="mt-3">
                    <p className="text-[14px] font-[700]">
                      Everything on <span className="font-[800]">Plan</span>:
                    </p>
                    <ul className="mt-2 space-y-2 text-[14px] text-[#303030]">
                      {[
                        "Many offers available",
                        "Benefits and savings",
                        "1 year membership",
                        "Exclusive experiences",
                        "Digital & easy",
                      ].map((text) => (
                        <li key={text} className="flex items-center gap-2">
                          <span
                            className="inline-flex items-center justify-center w-[18px] h-[18px] rounded-full"
                            style={{ background: "#13A0E1" }}
                          >
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5 10.5l3 3 7-7"
                                stroke="#FFFFFF"
                                strokeWidth="2.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                          <span>{text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="mt-3 bg-white rounded-[16px] shadow-[0_8px_24px_rgba(0,0,0,0.08)] p-5 border border-[#EFF2F5]">
                  <div className="text-[14px] font-[700] text-[#303030] mb-2">
                    Choose a fundraiser to support
                  </div>
                  <div className="space-y-3 relative">
                    <SearchableSelect
                      variant="mobile"
                      label="Fundraiser Category"
                      placeholder="Select category"
                      options={memberVisibleFundraiserCategoryOptions}
                      value={fundCategory}
                      onFocus={() => {
                        setFundSubcatOpen(false);
                      }}
                      onChange={(value) => {
                        handleFundraiserCategoryChange(value || "");
                        blurActiveSelect();
                      }}
                    />

                    {(!fundCategory || selectedCategoryRequiresSubcategory) && (
                      <div className="relative" ref={fundSubcatRef}>
                        <div className="text-[12px] font-[600] text-[#303030] mb-1">
                          Sub-category
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            setFundSubcatOpen((s) => !s);
                          }}
                          className="w-full min-h-[40px] rounded-[6px] border border-[#EFF2F5] bg-[#F3F6F9] px-3 py-2 text-[13px] font-poppins flex items-center justify-between"
                        >
                          <div className="flex flex-wrap gap-1 items-center flex-1">
                            {fundSubcatIds.length === 0 ? (
                              <span className="text-[#8C8C8C]">
                                Select sub-category
                              </span>
                            ) : (
                              (subCategories || [])
                                .filter((s) =>
                                  fundSubcatIds.includes(s._id || s.id),
                                )
                                .map((s) => (
                                  <span
                                    key={s._id || s.id}
                                    className="inline-flex items-center gap-1 px-2 py-1 bg-white border border-[#E1E1E1] rounded-full text-[11px] text-[#303030] hover:bg-[#F8F9FA] transition-colors"
                                  >
                                    {s.title}
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        removeSubCategoryChip(s._id || s.id);
                                      }}
                                      className="ml-1 text-[#8C8C8C] hover:text-[#FF4444] transition-colors"
                                      aria-label="Remove"
                                    >
                                      <svg
                                        className="w-3 h-3"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M5 5l10 10M15 5L5 15"
                                          stroke="currentColor"
                                          strokeWidth="1.8"
                                          strokeLinecap="round"
                                        />
                                      </svg>
                                    </button>
                                  </span>
                                ))
                            )}
                          </div>
                          <svg
                            className={`w-4 h-4 text-[#303030] transition-transform ${fundSubcatOpen ? "rotate-180" : ""}`}
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.08z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                        <div
                          className={`absolute left-0 right-0 mt-2 origin-top transition-all duration-200 ${fundSubcatOpen ? "opacity-100 scale-y-100" : "opacity-0 scale-y-0 pointer-events-none"} bg-white border border-[#EFF2F5] rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.08)] z-50`}
                        >
                          <div className="max-h-[220px] overflow-auto py-2">
                            {!fundCategory ? (
                              <div className="px-3 py-2 text-[12px] text-[#8C8C8C]">
                                Select category first
                              </div>
                            ) : fundraiserLoading ? (
                              <div className="px-3 py-2 text-[12px] text-[#8C8C8C]">
                                Loading...
                              </div>
                            ) : subCategories?.length > 0 ? (
                              subCategories.map((c) => {
                                const cid = c._id || c.id;
                                const selected = fundSubcatIds.includes(cid);
                                return (
                                  <button
                                    key={cid}
                                    type="button"
                                    onClick={() => {
                                      toggleSubCategory(c.title);
                                    }}
                                    className={`w-full text-left px-3 py-2 text-[13px] font-poppins transition-all duration-200 hover:bg-[#F3F6F9] ${selected ? "bg-[#EAF7FF] text-[#00ADEF] font-[600]" : "text-[#303030]"}`}
                                  >
                                    <div className="flex items-center justify-between">
                                      <span>{c.title}</span>
                                      {selected && (
                                        <svg
                                          className="w-4 h-4 text-[#00ADEF]"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      )}
                                    </div>
                                  </button>
                                );
                              })
                            ) : (
                              <div className="px-3 py-2 text-[12px] text-[#8C8C8C]">
                                No subcategories available
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    <SearchableSelect
                      variant="mobile"
                      label="Fundraiser Name"
                      placeholder="Select fundraiser"
                      options={fundraiserOptions}
                      value={fundName}
                      loading={fundraiserLoading}
                      onSearch={(v) => setFundraiserNameSearch(v || "")}
                      onInputKeyDown={(e) => {
                        if (e?.key !== "Enter") return;
                        const typed = String(fundraiserNameSearch || "").trim();
                        if (!typed) return;
                        const exactMatch = fundraiserOptions.some(
                          (opt) => opt?.value === typed,
                        );
                        if (!exactMatch) {
                          e.preventDefault();
                          e.stopPropagation();
                        }
                      }}
                      onFocus={() => {
                        setFundSubcatOpen(false);
                      }}
                      onChange={(value) => {
                        handleFundraiserNameChange(value || "");
                        blurActiveSelect();
                      }}
                    />
                  </div>
                </div>

                <div
                  className="flex justify-between fixed left-0 right-0 bottom-5 px-6 z-50 bg-white pt-4"
                  style={{ boxShadow: "0 -1px 0 #E6E6E6" }}
                >
                  <PrimaryButton
                    type="button"
                    label="Back"
                    onClick={() => setStep(2)}
                    className="w-[48%] h-[52px] rounded-[10px] bg-white text-[#A6A6A6] border border-[#CFCFCF] font-[600]"
                  />
                  <PrimaryButton
                    type="submit"
                    label="Proceed"
                    loading={subscriptionLoading}
                    className="w-[48%] h-[52px] rounded-[10px] text-[16px] font-[600]"
                    disabled={authLoading || subscriptionLoading}
                  />
                </div>
                */}
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {showRestoreModal && (
        <ConfirmationPopup
          image={QuestionMarkIcon}
          heading="Restore your account?"
          content="Your account has been deleted. Are you sure you want to
          retrieve it?"
          handleNo={() => setShowRestoreModal(false)}
          handleYes={handleRestoreConfirmation}
        />
      )}

      {/* Skip Modal */}
      {/* {showSkipModal && (
        <div className="fixed inset-0 z-[100]">
          <div className="absolute inset-0 bg-black/50" onClick={()=> setShowSkipModal(false)} />
          <div className="absolute inset-0 flex items-center justify-center px-6">
            <div className="w-full max-w-[320px] bg-white rounded-[14px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] p-5 text-center">
              <div className="mx-auto mb-3 w-[56px] h-[56px] rounded-full flex items-center justify-center bg-white" style={{boxShadow:'0 0 0 2px #13A0E1 inset',}}>
                <svg width="28" height="28" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 10.5l3 3 7-7" stroke="#13A0E1" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="text-[18px] font-[800] text-[#303030]">Account Created Successfully</h3>
              <p className="mt-2 text-[12px] text-[#8C8C8C] leading-5">Your Swoodle account is now active. Upgrade anytime to unlock full subscription benefits.</p>
              <button type="button" onClick={()=>{ try{ localStorage.removeItem("memberSetup.step"); localStorage.removeItem("memberSetup.email"); localStorage.removeItem("userProfile"); localStorage.removeItem("userPassword"); localStorage.removeItem("memberSetup.fund"); }catch(_){}; handleSkipLoginDeepLink(); }} className="mt-5 w-full h-[44px] rounded-[8px] text-white font-[500]" style={{background:'#13A0E1'}}>Log In</button>
            </div>
          </div>
        </div>
      )} */}
    </form>
    {showLinkedAccountPasswordModal && (
      <LinkedAccountPasswordModal
        email={email}
        roles={existingAccountRoles}
        targetRole="member"
        onVerify={handleLinkedAccountPassword}
        onForgotPassword={handleForgotLinkedAccountPassword}
        onUseDifferentEmail={handleUseDifferentMemberEmail}
      />
    )}
    </>
  );
};

export default MobileView;
